import Navbar from "../components/navbar/Navbar";
import Sidebar from "../components/sidebar/Sidebar";
import Feed from "../components/feed/Feed";
import Rightbar from "../components/rightbar/Rightbar";
import "./home.css";
import Partilhar from "../components/partilhar/Partilhar";

export default function home() {
  return (
    <>
      <div className="row" style={{ marginTop: 20 }}>
        <Sidebar />
        <div className="col-xxl-6 col-lg-6 col-md-6 feedSticky">
          <Partilhar />
          <Feed />
          <div className="text-center mb-3">
            <a className="text-danger">
              <i className="mdi mdi-spin mdi-loading me-1 font-16"></i> a
              carregar{" "}
            </a>
          </div>
        </div>
        <Rightbar />
      </div>
    </>
  );
}
